import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function Comparison() {
  const features = [{
    name: 'Setup',
    traditional: 'DIY Setup',
    stopply: 'Custom Built'
  }, {
    name: 'Design',
    traditional: 'Generic Templates',
    stopply: 'Done With You'
  }, {
    name: 'Time to Value',
    traditional: 'Weeks to Launch',
    stopply: 'Launch Today'
  }, {
    name: 'Support',
    traditional: 'Software Only',
    stopply: 'Managed by Experts'
  }, {
    name: 'Evolution',
    traditional: 'Static Reports',
    stopply: 'Continuously Improving'
  }, {
    name: 'Data',
    traditional: 'Disconnected Data',
    stopply: 'One Source of Truth'
  }, {
    name: 'Strategy',
    traditional: 'No Strategic Guidance',
    stopply: 'Business Decision Platform'
  }];
  return <section className="py-32" data-id="element-39">
      <div className="max-w-5xl mx-auto px-6" data-id="element-40">
        <div className="text-center mb-20" data-id="element-41">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-bold mb-6" data-id="element-42">
            Not another dashboard.
            <br data-id="element-43" />
            <span className="text-textSecondary" data-id="element-44">
              A better way to run your business.
            </span>
          </motion.h2>
        </div>

        <div className="glass-panel rounded-3xl overflow-hidden" data-id="element-45">
          <div className="grid grid-cols-3 border-b border-white/5 bg-secondary/50" data-id="element-46">
            <div className="p-6 font-medium text-textSecondary" data-id="element-47">Feature</div>
            <div className="p-6 font-medium text-textSecondary text-center" data-id="element-48">
              Traditional BI
            </div>
            <div className="p-6 font-medium text-accent text-center bg-accent/5" data-id="element-49">
              Stopply
            </div>
          </div>

          <div className="divide-y divide-white/5" data-id="element-50">
            {features.map((feature, i) => <motion.div key={i} initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} className="grid grid-cols-3 hover:bg-white/[0.02] transition-colors" data-id="element-51">
                <div className="p-6 text-sm font-medium text-white flex items-center" data-id="element-52">
                  {feature.name}
                </div>
                <div className="p-6 text-sm text-textSecondary text-center flex items-center justify-center gap-2" data-id="element-53">
                  <X size={16} className="text-accent/60" data-id="element-54" />
                  {feature.traditional}
                </div>
                <div className="p-6 text-sm text-white text-center flex items-center justify-center gap-2 bg-accent/5" data-id="element-55">
                  <Check size={16} className="text-accent" data-id="element-56" />
                  {feature.stopply}
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}